module.exports = __webpack_public_path__ + "img/booth_en_2_2.809ca648.png";